import { handleActions } from "redux-actions";
import {
    mergeTestCaseReportDialog,
    setTestCaseReportDialog
} from "modules/ConfigCI/services/ReportCase/actions";

const initialState = {
    title: "",
    isOpen: false,
    isLoading: false,
    content: ""
};

export const reportCaseReducer = handleActions(
    {
        [setTestCaseReportDialog]: (state, { payload }) => ({
            ...initialState,
            ...payload
        }),
        [mergeTestCaseReportDialog]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
